import React from 'react';
import { Position, NodeProps } from '@xyflow/react';
import BaseNode from '../BaseNode';
import { useTranslation } from 'react-i18next';

const FilterNode: React.FC<NodeProps<any>> = ({ data, selected, type, id, ...props }) => {
  const { t } = useTranslation();
  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>
  );
  return (
    <BaseNode
      id={id}
      data={data}
      type={type}
      selected={selected}
      className="px-4 py-2"
      icon={icon}
      label={data?.label || 'Filter'}
      // 조건은 노드 설정(config)에 있다 — 예전에는 data.condition 을 읽어 조건이 있어도 '조건 입력' 안내가 떴다
      subtitle={data?.config?.condition || data?.condition || t('workflow:node.addCondition')}
      {...props}
    />
  );
};

export default FilterNode; 